import { Box } from '@mui/material';
import { useState } from 'react';
import Feedback from '../special/Feedback';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import * as Yup from 'yup';
import ExoForm from '../exo/ExoForm';
import { useTranslation } from 'react-i18next';
import Loader from '../special/Loader';

const NewService = ({ onClose, onCreate = () => {}, startData, fullWidth }) => {
  const { t } = useTranslation();

  const fields = [
    {
      label: `${t('Picture')} (${t('optional')})`,
      type: 'image',
      key: 'image',
    },
    {
      label: t('Name'),
      type: 'text',
      key: 'name',
    },
    {
      label: `${t('Description')} (${t('optional')})`,
      type: 'description',
      key: 'description',
    },
    {
      label: `${t('Categories')} (${t('optional')})`,
      type: 'serviceCategoryIds',
      key: 'serviceCategoryIds',
    },
    {
      label: `${t('Unit')} (${t('optional')})`,
      type: 'text',
      key: 'unit',
    },
    {
      label: t('Tax Rate'),
      type: 'text',
      key: 'taxRate',
      unit: '%',
    },
    {
      label: t('Price'),
      type: 'money',
      key: 'price',
      unit: '€',
    },
  ];
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);
  function handleSubmit(service) {
    DBRequest({
      config,
      path: service.id ? `services/${service.id}` : 'services',
      method: service.id ? API_PATCH(service) : API_POST(service),
      onResponse: handleData,
      onFeedback: handleFeedback,
      onLoading: setIsLoading,
    });
  }
  function handleData(data) {
    onCreate(data.data);
    onClose();
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <Box
      className="p-2 h-full overflow-y-auto"
      sx={{ width: fullWidth ? '100%' : '700px', maxWidth: '100%' }}
    >
      <Loader active={isLoading} />
      <ExoForm
        draftType={'service'}
        startDataCollection={startData}
        fields={fields}
        onCancel={onClose}
        header={t('New Service')}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        noDifferences={Boolean(startData && !startData.id)}
      />
      <Feedback setState={setAlertState} state={alertState} />
    </Box>
  );
};

// validation
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  price: Yup.number()
    .typeError('Price must be a number')
    .required('Price is required'),
  taxRate: Yup.number()
    .typeError('Tax rate must be a number')
    .required('Tax rate is required'),
});

export default NewService;
